
import { SiriusBaseComponent } from 'sirius-framework';
import { Component, Output, EventEmitter, ViewChild, TemplateRef } from '@angular/core';
import { CommonService } from '../../shared/service/shared.service';
import { AccModelList } from '../../shared/models/shared.model';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

declare const $: any;

/** String resource — boşsa Türkçe varsayılan */
const OWN_ACCOUNTS_KEYS = {
    modalTitle: 'yediEminOwnAccountsModalTitle',
    btnSelect: 'yediEminOwnAccountsBtnSelect',
    noAccountMessage: 'yediEminOwnAccountsNoAccountMessage',
    btnClose: 'yediEminOwnAccountsBtnClose',
};

@Component({ 
    selector: 'own-accounts',
    templateUrl: './own-accounts.component.html',
    styleUrls: ['./own-accounts.component.css']
})
export class OwnAccountsComponent extends SiriusBaseComponent<any> {   
    @Output('OnSelect') onSelect = new EventEmitter<string>();

    @ViewChild("ownAccTemplate") ownAcctemp: TemplateRef<any>;
  modalRef: BsModalRef;
  noAccount: boolean = false;
    list: AccModelList;

    modalTitle = 'Hesaplarımdan Seç';
    btnSelect = 'Seç';
    noAccountMessage = 'Uygun QNB hesabınız bulunmamaktadır.';
    btnClose = 'Kapat';
  constructor(private commonService: CommonService,
    private modalService: BsModalService) {
        super();
    }
    OnInit() {
        this.loadOwnAccountsResourceStrings();
        var promise = this.commonService.GetUserOwnAccounts(this.dataService);
        promise.then((result: AccModelList) => {
            if (result != null && result.AccList != null) {
              this.list = result;
              if (this.list.AccList.length == 0)
                this.noAccount = true;
            }
            else {
              this.list = null;
              this.noAccount = true;
            }
        });
    }

    private loadOwnAccountsResourceStrings(): void {
        const r = (key: string, fallback: string) => this.commonService.getStringResource(key, fallback);
        this.modalTitle = r(OWN_ACCOUNTS_KEYS.modalTitle, this.modalTitle);
        this.btnSelect = r(OWN_ACCOUNTS_KEYS.btnSelect, this.btnSelect);
        this.noAccountMessage = r(OWN_ACCOUNTS_KEYS.noAccountMessage, this.noAccountMessage);
        this.btnClose = r(OWN_ACCOUNTS_KEYS.btnClose, this.btnClose);
    }

    select(accNumber: string) {
        this.modalRef.hide();
        this.onSelect.emit(accNumber);
    }
    showPopup() {
      this.modalRef = this.modalService.show(this.ownAcctemp);
    }

  close() {
    this.modalRef.hide();
  }
}
